import { render, staticRenderFns } from "./EditSurgeryInfo.vue?vue&type=template&id=3b3822b4&v-slot%3Amodal-body=true&"
import script from "./EditSurgeryInfo.vue?vue&type=script&lang=js&"
export * from "./EditSurgeryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports